@if (display) {
  <h4 style="text-align:center; padding-top: 20px;"
    style='display: none;' data-test-id="no-results-found-message"
  > No results were found for the criteria selected</h4>
}
